import React from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';

import ProgressBar from '@hydra/common/components/ProgressBar';
import { Criterium, CriteriumSkeleton, CriteriumCompetitors } from '@hydra/common/criterium';
import { useReviewContext, usePdfTemplateContext } from '@hydra/common/context';

import formatNumber from '@hydra/utils/formatNumber';
import { getContrastedColor, getPriSecColors } from '@hydra/utils/colors';
import hasCritData from '@hydra/utils/hasCritData';
import { withLogarithmicScale } from '@hydra/utils/scale';

import { useI18n } from '@hydra/common/customHooks';

const useStyles = makeStyles(theme => ({
  number: {
    marginBottom: theme.spacing(1)
  }
}));

export const BacklinksRefDomains = ({ criterium, competitors = [] }) => {
  const classes = useStyles();
  const { numeral } = useI18n();

  const { isPdf, variant } = useReviewContext();
  const { templateColors } = usePdfTemplateContext();
  const { data, url } = criterium;

  const { primary, secondary } = isPdf
    ? templateColors
    : getPriSecColors();
  const color = getContrastedColor(primary);

  const scaledData = withLogarithmicScale([data, ...competitors.map(({ criteria }) => criteria.backlinks_ref_domains && criteria.backlinks_ref_domains.data)]);

  const singleContent = (
    <>
      {variant === 'nocrit' ? <CriteriumSkeleton width='30%' /> : <div className={classes.number}>{formatNumber(data)}</div>}
      {
        variant === 'nocrit'
          ? <CriteriumSkeleton />
          : <ProgressBar
              value={scaledData[0]}
              color={color}
            />
      }
    </>
  );
  let compContent;
  if (competitors.length > 0) {
    const compComponents = [
      { component: singleContent, url },
      ...competitors.map(({ criteria }, index) => {
        if (!hasCritData(criteria.backlinks_ref_domains)) {
          return null;
        }
        const { data, url } = criteria.backlinks_ref_domains;
        return {
          component: (
            <>
              {variant === 'nocrit' ? <CriteriumSkeleton width='30%' /> : <div className={classes.number}>{formatNumber(data)}</div>}
              {
                variant === 'nocrit'
                  ? <CriteriumSkeleton />
                  : <ProgressBar
                      value={scaledData[index + 1]}
                      color={secondary[index]}
                    />
              }
            </>
          ),
          url
        };
      })
    ];
    compContent = variant === 'nocrit' ? <CriteriumSkeleton width='30%' /> : <CriteriumCompetitors competitors={compComponents} />;
  }

  return (
    <Criterium
      criterium={criterium}
      variables={{ domain: url, backlinksCount: numeral(data).format() }}
    >
      {compContent || singleContent}
    </Criterium>
  );
};

BacklinksRefDomains.propTypes = {
  competitors: PropTypes.arrayOf(
    PropTypes.shape({
      criteria: PropTypes.shape({
        backlinks_ref_domains: PropTypes.shape({
          data: PropTypes.number,
          url: PropTypes.string
        })
      }),
      color: PropTypes.string
    })
  ),
  criterium: PropTypes.shape({
    data: PropTypes.number
  })
};

export default React.memo(BacklinksRefDomains);
